import { getFileIco, getSize } from "../../../utils";
import { FilePack } from "../../model";
 
export const MEDIA_FILE = '80B3F478-5EEE-417B-944F-48324B8FE72F';

export function createFileDom(taskId,file:File) {
    var ico = getFileIco(file.name);
    var sizeStr=getSize(file.size);
    var html = ` <file-element file-key='[` + MEDIA_FILE + `]' taskid='`+taskId+`' style='border: 1px solid #d0d0d0;padding: 7px;width: 270px;display: flex;'>
                    <div contenteditable='false' style='width: 30px;margin-right: 7px;'><img src=` + ico + ` /></div>
                    <div contenteditable='false'  style='width: 215px;'>
                    <div style='overflow: hidden;text-overflow:ellipsis;white-space: nowrap;'>` + file.name + `</div>
                    <div style='color: #b2b2b2e0;'>`+ sizeStr + `</div>
                    </div>
                </file-element><br/>`;
    document.execCommand('inserthtml', false, html);
}